import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOUR_HISTORY: "Din historikk",
      WHEN_WILL_I_RECIEVE_MY_DISCOUNT: "Når får jeg min rabatt?",
      AS_SOON_AS_YOUR_FRIEND_HAS_RECEIVED_HIS_FIRST_DELIVERY:
        "Så snart vennen din har mottatt sin første leveranse.",
      SHOW_MY_ACTIVE_DISCOUNTS: "Vis mine aktive rabatter",
      ALL_YOUR_REFERRALS_SINCE_YOU_CREATED_YOUR_ACCOUNT:
        "Alle du har vervet siden kontoen din ble opprettet",
      ACCOUNTS_CREATED_WITH_YOUR_CODE: "Kontoer opprettet med din kode",
      YOUR_RECEIVED_DISCOUNTS: "Dine mottatte rabatter",
    },
    se: {
      YOUR_HISTORY: "Din historik",
      WHEN_WILL_I_RECIEVE_MY_DISCOUNT: "När får jag min rabatt?",
      AS_SOON_AS_YOUR_FRIEND_HAS_RECEIVED_HIS_FIRST_DELIVERY:
        "Så fort din vän tagit emot sin första leverans.",
      SHOW_MY_ACTIVE_DISCOUNTS: "Visa mina aktiva rabatter",
      ALL_YOUR_REFERRALS_SINCE_YOU_CREATED_YOUR_ACCOUNT:
        "Alla dina värvningar sedan du skapade ditt konto.",
      ACCOUNTS_CREATED_WITH_YOUR_CODE: "Konton skapade med din kod",
      YOUR_RECEIVED_DISCOUNTS: "Dina mottagna rabatter",
    },
    dk: {
      YOUR_HISTORY: "Din historik",
      WHEN_WILL_I_RECIEVE_MY_DISCOUNT: "Hvornår får jeg min rabat?",
      AS_SOON_AS_YOUR_FRIEND_HAS_RECEIVED_HIS_FIRST_DELIVERY:
        "Du modtager rabatten, så snart din ven har modtaget sin første måltidskasse.",
      SHOW_MY_ACTIVE_DISCOUNTS: "Vis mine aktive rabatter",
      ALL_YOUR_REFERRALS_SINCE_YOU_CREATED_YOUR_ACCOUNT:
        "Alle dine anbefalinger siden oprettelse af din konto",
      ACCOUNTS_CREATED_WITH_YOUR_CODE: "Andres brug af din henvisningskode",
      YOUR_RECEIVED_DISCOUNTS: "Dine modtagne rabatter",
    },
  } as const
)[language];
